import { NavLink, withRouter } from 'react-router-dom'
import React from 'react'
import { TableVirtualized } from '../root/components/common/table-virtualized/table'
import { useSelector } from 'react-redux'
import { makeStyles, Typography } from '@material-ui/core'
import classNames from 'classnames'
import { getFormattedDate } from '../../utils'

const useStyles = makeStyles(theme => ({
    nameLink: {
        ...theme.link
    }
}))

const ExternalUsersBillingTableComponent = ({ data }) => {
    const { locale } = useSelector(state => state.main)

    const classes = useStyles()

    const Link = prop => <NavLink target={'_blank'} {...prop} />

    const handleLinkClick = e => {
        e.stopPropagation()
    }

    const columns = [
        {
            key: 'name',
            label: locale.common.name,
            sortable: false,
            dataType: 'string',
            width: 1.5,
            minWidth: 140,
            render: ({ rowData, cellData }) => {
                return (
                    <Typography noWrap variant="inherit">
                        {rowData.removed_at ? (
                            rowData.user_name
                        ) : (
                            <Link
                                onClick={handleLinkClick}
                                className={classNames(classes.nameLink)}
                                to={`/user-management/users/${rowData.user_id}`}
                            >
                                {rowData.user_name}
                            </Link>
                        )}
                    </Typography>
                )
            }
        },
        {
            key: 'email',
            label: locale.common.email,
            sortable: false,
            width: 1.5,
            dataType: 'string',
            render: ({ rowData, cellData }) => {
                return (
                    <Typography noWrap variant="inherit">
                        {rowData.removed_at ? (
                            rowData.user_email
                        ) : (
                            <Link
                                onClick={handleLinkClick}
                                className={classNames(classes.nameLink)}
                                to={`/user-management/users/${rowData.user_id}`}
                            >
                                {rowData.user_email}
                            </Link>
                        )}
                    </Typography>
                )
            }
        },
        {
            key: 'removed_at',
            label: locale.billing.removedAt,
            sortable: false,
            dataType: 'date',
            width: 1,
            render: ({ rowData }) =>
                rowData.removed_at ? (
                    <div>{getFormattedDate(rowData.removed_at)}</div>
                ) : (
                    '--'
                )
        }
    ]

    const navigateToUser = rowObj => {
        if (!rowObj.rowData.removed_at) {
            window.open(
                `/user-management/users/${rowObj.rowData.user_id}`,
                '_blank'
            )
        }
    }

    return (
        <TableVirtualized
            data={data}
            columns={columns}
            onRowClick={navigateToUser}
        />
    )
}

const ExternalUsersBillingTable = withRouter(ExternalUsersBillingTableComponent)
export { ExternalUsersBillingTable }
